import { isAllowed } from '../Apollo/allower';
import permissions from '../Apollo/permissions';

export default function isAllowedToDeliverEvents() {
  return isAllowed(permissions.deliverEvents);
}
